import { Field, useFormState } from 'react-final-form'

import { SelectValue } from 'common/components/BaseSelect'
import FormItem from 'common/components/formItem'
import Input from 'common/components/input'
import Textarea from 'common/components/textarea'
import { MergeTagListItem } from 'features/admin/accountSettings/api'

const validate = (value: string) => {
  if (!value) {
    return 'Required'
  }
}

type Props = {
  selectedCategory: SelectValue
  systemMergeTags?: MergeTagListItem[]
  isDisabled?: boolean
}

const CategoryDescription = ({
  systemMergeTags,
  selectedCategory,
  isDisabled,
}: Props) => {
  const { values } = useFormState()

  const description = systemMergeTags?.find(
    (tag) => tag.id === selectedCategory?.value
  )?.description

  const isCustom = selectedCategory?.value === 'custom'

  const initialValue = values['merge_tag_description'] ?? description ?? ''

  return (
    <>
      {isCustom && (
        <Field<string>
          name="merge_tag_custom_category_name"
          validate={validate}
          render={({ input, meta }) => (
            <FormItem
              label="Custom category name"
              htmlFor="merge_tag_custom_category_name"
              className="flex-none"
              error={meta.touched ? meta.error : undefined}
            >
              <Input
                type="text"
                id="merge_tag_custom_category_name"
                variant="default"
                className="text-coolGray-800"
                value={input.value}
                name={input.name}
                onChange={input.onChange}
                onFocus={input.onFocus}
                onBlur={input.onBlur}
                disabled={isDisabled}
              />
            </FormItem>
          )}
        />
      )}
      <Field<string>
        name="merge_tag_description"
        initialValue={initialValue}
        validate={validate}
      >
        {({ input, meta }) => (
          <FormItem
            label="Category description"
            htmlFor={input.name}
            className="flex-none"
            error={meta.touched ? meta.error : undefined}
          >
            <Textarea
              maxLength={250}
              rows={4}
              disabled={!isCustom}
              placeholder={
                isCustom
                  ? 'Enter clear instructions + description: A first name tag is a placeholder used in digital messaging, like emails or SMS, that dynamically inserts each recipient’s first name into the content. '
                  : 'Enter a clear description of the personalisation tag so that the model has the context to use it correctly.'
              }
              {...input}
            />
          </FormItem>
        )}
      </Field>
    </>
  )
}

export default CategoryDescription
